import Vue from 'vue';
export default Vue.extend({
    props: {
        imageSrc: {
            type: String,
            default: '',
        },
        zoom: {
            type: Number,
            default: 2,
        },
        size: {
            type: Number,
            default: 250,
        },
        nameToAlt: {
            type: String,
            default: '',
        },
    },
    data() {
        return {
            glassPosition: '',
            glassX: 0,
            glassY: 0,
            borderWidth: 1,
            imageElement: null,
            display: 'none',
        };
    },
    computed: {
        glassStyle() {
            if (this.imageElement === null) {
                return {};
            }
            return {
                left: `${this.glassX <= 0
                    ? 0
                    : this.glassX + this.size > this.imageElement.width
                        ? 'unset'
                        : this.glassX + 'px'}`,
                top: `${this.glassY <= 0
                    ? 0
                    : this.glassY + this.size > this.imageElement.height
                        ? 'unset'
                        : this.glassY + 'px'}`,
                bottom: `${this.glassY + this.size > this.imageElement.height ? 0 : 'unset'}`,
                right: `${this.glassX + this.size > this.imageElement.width ? 0 : 'unset'}`,
                width: `${this.size}px`,
                height: `${this.size}px`,
                display: this.display,
            };
        },
        previewStyle() {
            if (this.imageElement === null) {
                return {};
            }
            return {
                backgroundImage: `url(${this.imageSrc})`,
                backgroundPosition: this.glassPosition,
                backgroundSize: `${this.imageElement.width * this.zoom}px ${this.imageElement.height * this.zoom}px`,
                width: `${this.size * 2}px`,
                height: `${this.size * 2}px`,
                left: `${this.imageElement.offsetWidth + 25}px`,
                display: this.display,
            };
        },
    },
    created() {
        window.addEventListener('scroll', this.hideGlass);
    },
    destroyed() {
        window.removeEventListener('scroll', this.hideGlass);
    },
    mounted() {
        this.imageElement = this.$refs.image;
    },
    methods: {
        hideGlass() {
            this.display = 'none';
        },
        moveGlass(event) {
            event.preventDefault();
            if (!this.imageElement) {
                return;
            }
            this.display = 'block';
            let { x, y } = this.getCursorPosition(event);
            const width = this.imageElement.width;
            const height = this.imageElement.height;
            const glassHalf = this.size / 2;
            if (x > width || x < 0 || y > height || y < 0) {
                this.display = 'none';
            }
            this.glassX = x - glassHalf;
            this.glassY = y - glassHalf;
            let glassPositionX = x * this.zoom - this.size + this.borderWidth;
            let glassPositionY = y * this.zoom - this.size + this.borderWidth;
            this.glassPosition = `${-(glassPositionX <= 0
                ? 0
                : this.imageElement.width < this.glassX + this.size
                    ? (this.imageElement.width - this.size) * 2
                    : glassPositionX)}px ${-(glassPositionY <= 0
                ? 0
                : this.imageElement.height < this.glassY + this.size
                    ? (this.imageElement.height - this.size) * 2
                    : glassPositionY)}px`;
        },
        getCursorPosition(event) {
            if (!this.imageElement) {
                return { x: 0, y: 0 };
            }
            let x = 0;
            let y = 0;
            const imageRect = this.imageElement.getBoundingClientRect();
            x = event.pageX - imageRect.left;
            y = event.pageY - imageRect.top;
            x = x - window.pageXOffset;
            y = y - window.pageYOffset;
            return { x, y };
        },
    },
});
